import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmDialog } from "primereact/confirmdialog";
import { ContextMenu } from "primereact/contextmenu";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NewOrder from "./NewOrder";
import { apiClient } from "../apiClient";
import colors from '../colors';
import "../css/Manager.css";


function ManageArticles(props)
{

    const [articles,setArticles] = useState([]);
    const [updateArticles,setUpdateArticles] = useState(0);
    const [selectedArticle, setSelectedArticle] = useState({Title:"",content:"",indexedImage:"",creatorname:""});
    const cm = useRef(null);
    const cm2 = useRef(null);
    const toast = useRef(null);
    const token = JSON.parse(localStorage.getItem('userToken'));
    const onlineUser = JSON.parse(localStorage.getItem('seo_app') != null) ? JSON.parse(localStorage.getItem('seo_app')) : {username:"" , name:"", avatarPic:"profile-index.png"};
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const navigate = useNavigate();
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [showConfirmDeleteOrder, setShowConfirmDeleteOrder] = useState(false);
    const [showNewOrder, setShowNewOrder] = useState(false);
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
    const user = JSON.parse(localStorage.getItem('seo_app') != null) ? JSON.parse(localStorage.getItem('seo_app')) : { name: "" };
    

    const closeNewOrderDialog = () =>
    {
      setShowNewOrder(false);
      toast.current.show({severity: 'success', 
        summary:"درخواست مقاله شما ثبت شد. مقاله آماده شده نهایتاً تا 1 روز دیگر در پنل کاربری شما قرار خواهد گرفت" }); 

        setUpdateArticles(updateArticles+1);
    };


    // bodies *****************************************************************************************************
    const imageBodyTemplate = (rowData) => {
        
          return <img 
            src={`${process.env.REACT_APP_BACK}/articles/${rowData.indexedImage}`}
            style={{height:"70px",width:"70px", objectFit:'cover'}}

            >

        </img>      
        
    };
    const regDateBodyTemplate = (rowData) => {
        return new Date(rowData.createdDate).toLocaleDateString('fa-IR');
    };
    
    
    const titleBodyTemplate = (rowData) => {
      const maxLength = 50;
      const content = rowData.title || "";
    
      // Truncate content if it exceeds maxLength
      const truncatedContent = content.length > maxLength ? content.substring(0, maxLength) + '...' : content;
    
      return <div style={{width:'100px',wordWrap: "break-word"}}>{truncatedContent}</div>;
    };

  const metaBodyTemplate = (rowData) => {
    const maxLength = 100;
    const content = rowData.metaDescription || "";
  
    // Truncate content if it exceeds maxLength
    const truncatedContent = content.length > maxLength ? content.substring(0, maxLength) + '...' : content;
  
    return <div style={{width:'150px',wordWrap: "break-word"}}>{truncatedContent}</div>;
  };



  const secondryKeywordsBodyTemplate = (rowData) => {
    let r = "";
    if (rowData.secondryKeywords) {
        rowData.secondryKeywords.forEach(keyword => {
            const name = Object.keys(keyword)[0];
            const number_of_links = keyword[name];
            r += `- ${name}:${number_of_links}<br />`;
        });
    }

    return (
        <div style={{ width: '200px'}}>
            <div style={{ fontSize: "11px",textAlign:'right' }} dangerouslySetInnerHTML={{ __html: r }}></div> 
            {rowData.internalLinksCreated && 
                <span style={{ fontSize: "10px", color: "#219B9D ", border: "1px solid #219B9D ", padding: "0px 5px" , borderRadius:'30px' }}>
                    لینکهای داخلی ساخته شده
                </span>
            }
        </div>
    );
};

  const rankBodyTemplate = (rowData) =>
    {
      
      if(rowData.rank!==undefined)
        return (
          <div style={{display:"flex", alignItems:"center"}}>
              {( rowData.rank<10) && 
              (<i className="pi pi-star-fill" 
                style={{background: "green",borderRadius: "15px",width:"30px",height:"30px",padding: "10px",color: "#fff", fontSize:"11px",display:"flex",alignItems:"center"}}>
              </i>)}
          <Button 
            tooltip="آپدیت رتبه گوگل" tooltipOptions={{position:"top"}}
            style={{color: rowData.rank >= 20 ? "red" : "green", fontSize:"20px",cursor:"pointer",background:'transparent',border:"none"}}
            onClick={() => calculateRank(rowData.keyword)}
              >{rowData.rank}</Button>
            </div> );
      else
        return(<Button 
                tooltip="محاسبه رتبه گوگل" tooltipOptions={{position:"top"}}
                style={{color:"red", fontSize:"20px",cursor:"pointer",background:'transparent',border:"none"}}
                onClick={() => calculateRank(rowData.keyword)}
                  >؟</Button> );
      
      
    };


    const mobile_titleBody = (rowData) => { return <span className="mobile-body"><p className="col1">تیتر مقاله:</p> <p className="col2">{rowData.title}</p></span>}
    const mobile_keywordBody = (rowData) => { return <span className="mobile-body"><p className="col1">کلمه کلیدی:</p> <p className="col2">{rowData.keyword}</p></span>}
    const mobile_secondryKeywordsBody = (rowData) => { 
                  let r = "";
                if (rowData.secondryKeywords) {
                    rowData.secondryKeywords.forEach(keyword => {
                        const name = Object.keys(keyword)[0];
                        const number_of_links = keyword[name];
                        r += `- ${name}:${number_of_links}<br />`;
                    });
                }

                return (

                  <span className="mobile-body"><p className="col1">کلمات کلیدی فرعی (تعداد ارجاع داخلی):</p> 
                  
                  <div className="col2" style={{ width: '200px'}}>
                        <div style={{ fontSize: "11px",textAlign:'right' }} dangerouslySetInnerHTML={{ __html: r }}></div> 
                        {rowData.internalLinksCreated && 
                            <span style={{ fontSize: "10px", color: "#219B9D ", border: "1px solid #219B9D ", padding: "0px 5px" , borderRadius:'30px' }}>
                                لینکهای داخلی ساخته شده
                            </span>
                        }
                    </div>
                  
                  </span>
        
    );}
    const mobile_imageBody = (rowData) => { return <span className="mobile-body"><p className="col1">تصویر شاخص:</p> 
              <img 
                src={`${process.env.REACT_APP_BACK}/articles/${rowData.indexedImage}`}
                style={{height:"70px",width:"70px", objectFit:'cover'}}
               
                >

            </img> </span>}
    const mobile_metaBody = (rowData) => { return <span className="mobile-body"><p className="col1">توضیحات متا:</p> <p className="col2">{rowData.metaDescription}</p></span>}
    const mobile_rankBody = (rowData) => {
                if(rowData.rank!==undefined)
                  return (
                <span className="mobile-body"><p className="col1">رتبه گوگل:</p> 
                    <div style={{display:"flex", alignItems:"center"}}>
                        {( rowData.rank<10) && 
                        (<i className="pi pi-star-fill" 
                          style={{background: "green",borderRadius: "15px",width:"30px",height:"30px",padding: "10px",color: "#fff", fontSize:"11px",display:"flex",alignItems:"center"}}>
                        </i>)}
                    <Button 
                      tooltip="آپدیت رتبه گوگل" tooltipOptions={{position:"top"}}
                      style={{color: rowData.rank >= 20 ? "red" : "green", fontSize:"20px",cursor:"pointer",background:'transparent',border:"none"}}
                      onClick={() => calculateRank(rowData.keyword)}
                        >{rowData.rank}</Button>
                      </div>
                      </span> );
                else
                  return(
                  <span className="mobile-body"><p className="col1">رتبه گوگل:</p> 
                  <Button 
                          tooltip="محاسبه رتبه گوگل" tooltipOptions={{position:"top"}}
                          style={{color:"red", fontSize:"20px",cursor:"pointer",background:'transparent',border:"none"}}
                          onClick={() => calculateRank(rowData.keyword)}
                            >؟</Button> </span> );
                  }
      
      
    const mobile_regDateBody = (rowData) => { return <span className="mobile-body"><p className="col1">تاریخ ایجاد:</p> <p className="col2">{new Date(rowData.createdDate).toLocaleDateString('fa-IR')}</p></span>}

/************************************************************************************************************************/ 

    
    const calculateRank = async (keyword) =>
    {
      if(user.role === "manager")
      {
        await apiClient.get(process.env.REACT_APP_BACK+"/articles/calculate_rank/"+keyword, config)
        .then(response => 
          {
            if (response.status == 200)
            {
              if(response.data !=="error")
                toast.current.show({severity: 'info', summary:"رتبه گوگل آپدیت شد" }); 
              else
                toast.current.show({severity: 'error', summary:"مشکلی در آپدیت رتبه گوگل رخ داد" }); 
              setUpdateArticles(updateArticles+1);
              
            }

        })
        .catch(error => {
          console.log(error);
          
        });
      }
    }
    


  const showIconBodyTemplate = (rowData) =>
  {


      let status;
      if(rowData.status === "registered" || rowData.status ==="approve")
      {
        status="در حال تولید";
      return <div style={{ display: !desktop? "table" : null , margin:!desktop?"auto":null }}>
      <button  
        className="manager-button"
        style={{fontSize:'12px'}}
        
    >
      {status}</button>
      
      </div>
      }
      else
      {
        status = "نمایش مقاله"
      return <div style={{ display: !desktop? "table" : null , margin:!desktop?"auto":null }}>
      <button  
        className="manager-button"
        style={{fontSize:'12px',background:colors.primary,color:"#ffffff",fontFamily: "peyda-medium",width:'100%'}}
        onClick={() => showArticle(rowData._id)}
        
    >
      {status}</button>
       <button  
        className="manager-button"
        style={{fontSize:'12px',color:colors.primary,fontFamily: "peyda-medium",width:'100%',marginTop:'10px'}}
        onClick={() => showArticle(rowData._id)}
        
    > انتشار در وبسایت
      </button>
      
      </div>
      }

    
  }


    
    const menuModel = [
        {label: 'ویرایش', icon: 'pi pi-fw pi-pencil', command: () => navigate("/edit-article/", { state: { article: selectedArticle } })},
        {label: 'حذف', icon: 'pi pi-fw pi-trash', command: () => setShowConfirmDelete(true)}
    ];

    const menuModel2 = [
      {label: 'حذف', icon: 'pi pi-fw pi-trash', command: () => setShowConfirmDeleteOrder(true)}
  ];

  const showArticle =  async(_id) =>
    {
      await apiClient.get(process.env.REACT_APP_BACK+"/articles/" + _id, config)
      .then(response => 
        {
          if (response.status == 200)
          {
            
            const article = response.data;      
            window.open("/articles/user_"+article.creator._id+"/" +article.slug , "_blank");
            
          }

      })
      .catch(error => {
         console.log(error);
        
      });

    }




    const deleteArticleFromDB = async (_id) => 
    {
      await apiClient.delete(process.env.REACT_APP_BACK+"/articles/" + _id, config)
      .then(response => 
        {
          if (response.status == 200)
          {
            
            toast.current.show({severity: 'info', summary: 'مقاله حذف شد'});
            setUpdateArticles(updateArticles+1);    
            
          }

      })
      .catch(error => {
         console.log(error);
      
      });
    };

    const deleteOrderFromDB = async (_id) => 
      {
        await apiClient.delete(process.env.REACT_APP_BACK+"/orders/" + _id, config)
        .then(response => 
          {
            if (response.status == 200)
            {
              console.log(response);      
              toast.current.show({severity: 'info', summary: 'سفارش حذف شد'});
              setUpdateArticles(updateArticles+1);    
              
            }
  
        })
        .catch(error => {
           console.log(error);
       
        });
      };

   

    //get all articles and orders from database:
    useEffect(() => {
    async function getAllArticles() {

      
      //get articles:
      const result = await apiClient.get(process.env.REACT_APP_BACK+"/articles/articles_for_creator/"+onlineUser._id, config)
      .then(async (result) =>  {
        if (result.status == 200) {

          const result1 = result.data;
          

          //now get orders:
          const result2 = (await apiClient.get(process.env.REACT_APP_BACK+"/orders/orders_for_creator/"+onlineUser._id,config)).data;   
          setArticles(result1.concat(result2));
          
        
          
        }
      })
      .catch((error) => {
        console.log(error);
     
      });
      

    }
    getAllArticles();
  },[updateArticles]);

  
 

 

    

    return(

        <div id="manage-pages">

            <h2>
            مدیریت مقاله ها
            </h2>

            <span style={{display:'flex' , paddingRight: desktop ? '50px' : '15px', paddingBottom:'50px'}}>

            <button 
            style={{marginTop:"50px"}} 
            className="register-button"
            onClick={()=>setShowNewOrder(true)}
            >
                سفارش مقاله جدید</button>

               

             

            </span>

            

            <Toast ref={toast} position="center"></Toast>

            <ContextMenu model={menuModel} ref={cm} />
            <ContextMenu model={menuModel2} ref={cm2} />


{/* for desktop **************************************************************************/}

        {desktop?
            <DataTable 
              size="normal" 
              value={articles} 
              paginator 
              rows={20} 
              editMode="row"
              className="manager-table"
              contextMenuSelection={selectedArticle}
              onContextMenuSelectionChange={e => setSelectedArticle(e.value)}
              //if article , show edit and delete menus, if order, show edit and delete menus:
              onContextMenu={e => { if(!e.indexedImage?.status) cm.current.show(e.originalEvent);
                                    else cm2.current.show(e.originalEvent);
              }}
              style={{ width: desktop ? '95%' : null}}
              resizableColumns={false} 
              // autolayout={false}
            >
            
            
            <Column alignHeader="center" columnKey="title" align="center" field="title" header="تیتر مقاله" body={titleBodyTemplate}   filter ></Column>
            <Column alignHeader="center" columnKey="keyword" align="center" field="keyword" header="کلمه کلیدی"  style={{width:"20px"}} filter ></Column>
            <Column alignHeader="center" columnKey="secondryKeywords" align="center" field="secondryKeywords" header="کلمات کلیدی فرعی: تعداد ارجاع داخلی"  body={secondryKeywordsBodyTemplate} style={{width:"200px"}} ></Column>
            <Column alignHeader="center" columnKey="image" align="center" field="image" header="عکس شاخص" body={imageBodyTemplate}   ></Column>
            <Column alignHeader="center" columnKey="metaDescription" align="center" field="metaDescription" header="توضیحات متا" body={metaBodyTemplate}  ></Column>
            <Column alignHeader="center" columnKey="rank" align="center" field="rank" header="رتبه گوگل" sortable  body={rankBodyTemplate} style={{width:"20px"}} bodyStyle={{width:"20px"}}></Column>
            <Column alignHeader="center" columnKey="createdDate" align="center" field="createdDate" header="تاریخ ایجاد" body={regDateBodyTemplate} style={{width:"20px"}} sortable></Column>
            <Column alignHeader="center" columnKey="show" align="center" field="show" header="وضعیت" style={{width:"200px"}} body={showIconBodyTemplate} ></Column>
            
            
            </DataTable>

// for mobile ****************************************************************************************************:
            :
<DataTable 
              size="normal" 
              value={articles} 
              paginator 
              rows={20} 
              editMode="row"
              className="manager-table"
              contextMenuSelection={selectedArticle}
              onContextMenuSelectionChange={e => setSelectedArticle(e.value)}
              //if article , show edit and delete menus, if order, show edit and delete menus:
              onContextMenu={e => { if(!e.indexedImage?.status) cm.current.show(e.originalEvent);
                                    else cm2.current.show(e.originalEvent);
              }}
              style={{ width: desktop ? '95%' : null}}
              resizableColumns={false} 
              // autolayout={false}
            >
            
            
            <Column alignHeader="center" columnKey="title" align="center" field="title" header="تیتر مقاله" body={mobile_titleBody}   filter ></Column>
            <Column alignHeader="center" columnKey="keyword" align="center" field="keyword" header="کلمه کلیدی"  style={{width:"20px"}} body={mobile_keywordBody} filter ></Column>
            <Column alignHeader="center" columnKey="secondryKeywords" align="center" field="secondryKeywords" header="کلمات کلیدی فرعی: تعداد ارجاع داخلی"  body={mobile_secondryKeywordsBody} style={{width:"200px"}} ></Column>
            <Column alignHeader="center" columnKey="image" align="center" field="image" header="عکس شاخص" body={mobile_imageBody}   ></Column>
            <Column alignHeader="center" columnKey="metaDescription" align="center" field="metaDescription" header="توضیحات متا" body={mobile_metaBody}  ></Column>
            <Column alignHeader="center" columnKey="rank" align="center" field="rank" header="رتبه گوگل" sortable  body={mobile_rankBody} style={{width:"20px"}} bodyStyle={{width:"20px"}}></Column>
            <Column alignHeader="center" columnKey="createdDate" align="center" field="createdDate" header="تاریخ ایجاد" body={mobile_regDateBody} style={{width:"20px"}} sortable></Column>
            <Column alignHeader="center" columnKey="show" align="center" field="show" header="وضعیت" body={showIconBodyTemplate} ></Column>
            
            
            </DataTable>
}

            


            <ConfirmDialog 
            className={props.theme}
            visible={showConfirmDelete} 
            onHide={() => setShowConfirmDelete(false)} 
            message="آیا از حذف این مقاله مطمئنید؟"
            header="تایید حذف"
            icon="pi pi-info-circle"
            acceptLabel="بله"
            rejectLabel="نه"
            acceptClassName="accept"
            rejectClassName="reject"
            accept={() => deleteArticleFromDB(selectedArticle._id)} 
            reject={() => setShowConfirmDelete(false)} />


            <ConfirmDialog 
            className={props.theme}
            visible={showConfirmDeleteOrder} 
            onHide={() => setShowConfirmDeleteOrder(false)} 
            message="آیا از حذف این سفارش مطمئنید؟"
            header="تایید حذف"
            icon="pi pi-info-circle"
            acceptLabel="بله"
            rejectLabel="نه"
            acceptClassName="accept"
            rejectClassName="reject"
            accept={() => deleteOrderFromDB(selectedArticle._id)} 
            reject={() => setShowConfirmDeleteOrder(false)} />

            <Dialog
            className={props.theme}
                id="edit-user-dialog"
                
                visible={showNewOrder}
                onHide={() => {setShowNewOrder(false); }}
                >
            
          
        
            <NewOrder closeDialog={closeNewOrderDialog}></NewOrder>
      
            </Dialog>

        </div>
    );
}
  
export default ManageArticles;